import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <ContactSection />
        <AppSection />
        <FaqSection />
        <IndexSection />
        <CardsSection />
        <FeaturesSection />
        <TopicsSection />
        <CommentsSection />
        <AboutSection />
        <MediaSection />
        <UpdatesSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}